import(/* webpackMode: "eager" */ "/builds/dustintech/products/openweb-nordics/web/libraries/dustin-microsite/apps/productsite-beta/src/app/error.tsx");
